import React, { useCallback, useEffect, useRef, useState } from "react";
import Footer from "components/Footer";
import HomeBlog from "components/HomeBlog";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import globalRequest from "../../utils/global/globalRequest";
import { changeLoader } from "../../redux/reducers/loader";
import * as API from "../../utils/helper/Enum";
import { useDispatch, useSelector } from "react-redux";
import * as CUSTOM from "../../utils/helper/custom";
import { getAuth } from "../../redux/reducers/loginData";
import {
  Button,
  Img,
  Line,
  List,
  PagerIndicator,
  Slider,
  Text,
} from "components";
import ReelStorySlider from "components/Reels/index";
import ProductSlider from "components/ProductCard/ProductSlider";
import { getAllCategories } from "redux/reducers/allCategories";
import CategoryGrid from "components/CategoryGrid/index";
import FeatureCards from "components/WhyChooseToUs/index";
import CategorySlide from "components/CategorySlide";
import SubscribeCard from "components/Footer/subscribeEmailForm";
import { useAppFont } from "../../utils/helper/useAppFont";
const HomePage = () => {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const sliderRef = React.useRef(null);
  const dispatch = useDispatch();
  const auth = useSelector(getAuth);
  const navigate = useNavigate();
  const [blogList, setBlogList] = useState([]);
  const [blogItemCount, setblogItemCount] = useState(0);
  const [sliderState, setsliderState] = React.useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const observer = useRef(null);
  const [animatedSections, setAnimatedSections] = useState([]);
  const pageName = location.pathname === "/" ? "Home" : location.pathname;
  const allCategories = useSelector(getAllCategories);
  const homeFeaturedProducts = useSelector(state => state.products?.homeProducts || []);
  const [productList, setProductList] = useState([]);

  const [sliderOffset, setSliderOffset] = useState(0);

  const { interClass, headingClass, interFamily, headingFamily } = useAppFont();

  const sliderImages = [
  "/images/homeImage/topCake.png",
  "/images/homeImage/topCake1.png",
  "/images/homeImage/topCake2.png",
  "/images/homeImage/topCake3.png",
  "/images/homeImage/topCake4.png",
  "/images/homeImage/topCake5.png",
  "/images/homeImage/topCake6.png",
];

  const handleMouseMove = (event) => {
    const { clientX, clientY } = event;
    setMousePosition({ x: clientX / 80, y: clientY / 80 });
  };

  const getAllCategoryList = useCallback(async (type = "new") => {
      try {
        dispatch(changeLoader(true));
        let response = await globalRequest(
          API?.PRODUCTS?.All_PRODUCTS,
          "get",
          {},
          true,
        );
        response = response?.data;
        if (response?.status === "SUCCESS") {
          setProductList((prevList) => [...prevList, ...response?.data?.data]);
        }
      } catch (e) {
        setProductList([]);
      }
      dispatch(changeLoader(false));
    }, [dispatch,]);
  
    useEffect(() => {
      getAllCategoryList();
    }, [getAllCategoryList]);

    const addOnsCategory = allCategories?.find(
      (cat) => cat.slug === "add-ons"
    );

    const addOnsSubCategories = addOnsCategory?.subcategories || [];
  /**
   * Get blogs
   */
  const getBlogData = async () => {
    dispatch(changeLoader(true));
    setblogItemCount(0);
    try {
      let response = await globalRequest(
        `${API?.BLOGS?.GET_BLOCK_BY_CATEGORY_ID}`,
        "get",
        {},
        {
          params: {
            page: 1,
            limit: 10,
            user_id: auth?.id,
          },
        },
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        setBlogList(response?.data?.data);
        setblogItemCount(response?.data?.paginator?.itemCount);
      } else {
        setBlogList([]);
      }
    } catch (e) {
      setBlogList([]);
    }
    dispatch(changeLoader(false));
  };

  /**
   * like unline blog post
   */
  const likeBlog = async (id) => {
    if (auth?.id > 0) {
      try {
        let response = await globalRequest(
          `${API?.BLOGS?.LIKE_DISLIKE}`,
          "patch",
          {id: id , gaData: CUSTOM.getGACookieValues()},
          {},
          true
        );
        response = response?.data;
        if (response?.status == "SUCCESS") {
          setBlogList((prevBlogList) => {
            return prevBlogList.map((blog) => {
              if (blog.id === id) {
                return {
                  ...blog,
                  isLike: !blog?.isLike ? true : false,
                  likes: !blog?.isLike
                    ? Number(blog?.likes) + 1
                    : blog?.likes - 1,
                };
              }
              return blog;
            });
          });
        }
      } catch (e) { }
    }
  };

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      const animatedElements = entries
        .filter((entry) => entry.isIntersecting)
        .map((entry) => entry.target);

      setAnimatedSections((prevSections) => [
        ...prevSections,
        ...animatedElements,
      ]);
    });

    const sections = document.querySelectorAll(".my-element");
    sections.forEach((section) => {
      observer.current.observe(section);
    });

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);


  useEffect(() => {
    animatedSections.forEach((animatedSection) => {
      animatedSection.classList.add("animation");
    });
  }, [animatedSections]);

  useEffect(() => {
    getBlogData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
   CUSTOM.handleScrollDepth(pageName);
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("sessionStartFired")) return;

    const urlParams = new URLSearchParams(window.location.search);
    const utm_source = urlParams.get("utm_source");
    const utm_medium = urlParams.get("utm_medium");
    const utm_campaign = urlParams.get("utm_campaign");

    if (utm_source) {
      CUSTOM.trackSessionStart({
        utm_source,
        utm_medium,
        utm_campaign,
      });
      sessionStorage.setItem("sessionStartFired", "true");
    } else {
      const referrer = document.referrer;
      let source = "";

      if (referrer.includes("facebook.com") || urlParams.has("fbclid")) {
        source = "Facebook";
      }
      else if (referrer.includes("instagram.com") || urlParams.has("igshid")) {
        source = "Instagram";
      }
      else if (referrer.includes("twitter.com") || referrer.includes("x.com")) {
        source = "Twitter";
      }
      else if (referrer.includes("linkedin.com")) {
        source = "LinkedIn";
      }

      if (source) {
        CUSTOM.trackSessionStart({
          utm_source: source,
          utm_medium: "social",
        });
        sessionStorage.setItem("sessionStartFired", "true");
      }
    }
  }, []);

  useEffect(() => {
    if (!sliderRef.current) return;

    const totalWidth = sliderRef.current.scrollWidth / 2; // because we will duplicate images
    const speed = 1; // pixels per tick

    const interval = setInterval(() => {
      setSliderOffset((prev) => {
        if (prev >= totalWidth) return 0;
        return prev + speed;
      });
    }, 20);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="bg-white-A700 flex flex-col items-center justify-center mx-auto w-full">
        <div className="flex flex-col w-full">
          <section
            id="section-1"
            onMouseMove={handleMouseMove}
            style={{
              background: `
                linear-gradient(0deg, #FDF2F6 0%, #FDF2F6 100%),
                linear-gradient(to bottom right, #FDF2F6 0%, #F2D9EF 50%) bottom right / 50% 50% no-repeat,
                linear-gradient(to bottom left, #FDF2F6 0%, #F2D9EF 50%) bottom left / 50% 50% no-repeat,
                linear-gradient(to top left, #FDF2F6 0%, #F2D9EF 50%) top left / 50% 50% no-repeat,
                linear-gradient(to top right, #FDF2F6 0%, #F2D9EF 50%) top right / 50% 50% no-repeat
              `,
            }}
            className="
              relative
              w-full h-[747px]
              xs:h-auto xs:py-16
              overflow-hidden
    flex items-center justify-center max-w-[1400px] mx-auto px-4 sm:px-8
  "
          >
            <Img
              src="/images/decoration-item.png"
              alt="decor"
              className="
      absolute
      left-[80px]
      top-1/2
      -translate-y-1/2
      w-[120px]
      opacity-90
      xs:hidden
      pointer-events-none
    "
            />

            <Img
              src="/images/decoration-item.png"
              alt="decor"
              className="
      absolute
      left-[140px]
      bottom-[60px]
      w-[100px]
      opacity-90
      xs:hidden
      pointer-events-none
    "
            />

            <Img
              src="/images/decoration-item.png"
              alt="decor"
              className="
      absolute
      right-[6%]
      top-[30%]
      w-[120px]
      opacity-90
      xs:hidden
      pointer-events-none
    "
            />

            <Img
              src="/images/decoration-item.png"
              alt="decor"
              className="
      absolute
      right-[8%]
      bottom-[12%]
      w-[100px]
      opacity-90
      xs:hidden
      pointer-events-none
    "
            />

            <div className="relative w-full max-w-[1100px] px-4 sm:px-4 flex justify-center">
              <div className="max-w-[720px]  relative flex flex-col items-center text-center sm:text-left">
                <div className="relative w-full sm:pl-10 sm:pr-10">
                  <Img
                    src="/images/tom.png"
                    alt="tom"
                    className="
                      absolute
                      -top-2
                      sm:top-10
                      sm:left-[20%]
                      left-[65%]
                      -translate-x-1/2
                      w-10
                      h-10
                      sm:w-12
                      sm:h-10
                      z-10"
                  />

                  <h1
                    className={`
                      ${headingClass}
                      z-20
                      relative
                      font-bold
                      text-[#771237]
                      text-[56px]
                      md:text-5xl
                      leading-[64px] sm:leading-[50px]
                      sm:text-[42px] `}>
                    {t("makeHappiness")}
                  </h1>
                </div>

                <h1
                  className={`
                    ${headingClass}
                    font-bold
                    text-[#771237]
                    text-[56px]
                    leading-[64px] sm:leading-[50px]
                    md:text-5xl
                    sm:text-[42px]
                    sm:pl-10
                    sm:pr-10
                  `}
                >
                  {t("withPieceOfCake")}
                </h1>

                {/* Description */}
                <p
                  className={`
                    mt-4
                    max-w-[560px]
                    text-[#8D4660]
                    text-base
                    leading-6
                    ${interClass}
                    sm:pl-10
                    sm:pr-10
                  `}
                >
                  {t("fromcustomDesignstoPremiumIngredients")}
                </p>

                {/* Buttons */}
                <div className="mt-8 flex gap-4 w-full sm:flex-col flex-row sm:justify-start justify-center p-2">

                  <Button
                    className={`
                      relative
                      h-12
                      sm:w-full
                      px-8
                      rounded-full
                      bg-white
                      text-black-900
                      ${headingClass} font-semibold
                      text-[14px] leading-[20px]
                      shadow-[inset_0_4px_4px_rgba(255,255,255,0.25),_0_2px_24px_rgba(0,0,0,0.15)]
                      overflow-hidden
                      transition-all duration-500
                      hover:text-[#771237]
                      
                      hover:bg-[#FDF2F6]
                    `}
                     onClick={() => {
                        navigate("/all-products");
                      }}
                  >
                    {t("browseCakes")}
                  </Button>
                  <Button
                    className={`sm:w-full h-12 px-6 rounded-full bg-[#771237] text-white-A700 ${headingClass} font-semibold text-[14px] leading-[20px] shadow-[inset_0_4px_4px_rgba(255,255,255,0.25),_0_2px_24px_rgba(0,0,0,0.15)] transition-all duration-300 hover:bg-black `}
                    hover={true}
                    hoverclass="bg-black-900"
                    onClick={() => {
                      navigate("/design-my-cake");
                    }}
                  >
                    {t("customizedCakes")}
                  </Button>
                  {/* {!auth?.id && ( */}
                    <Button
                      className={`
                        relative
                        h-12
                        sm:w-full
                        px-8
                        rounded-full
                        bg-white
                        text-[#771237]
                        ${headingClass} font-semibold
                        text-[14px] leading-[20px]
                        shadow-[inset_0_4px_4px_rgba(255,255,255,0.25),_0_2px_24px_rgba(0,0,0,0.15)]
                        overflow-hidden
                        transition-all duration-500
                        hover:text-[#771237]
                      `}
                      onClick={() => navigate("/reservation")}
                    >
                      {t("stageAndCelebration")}
                    </Button>
                  {/* )} */}
                </div>
                <div className="relative w-screen mt-14 overflow-hidden">

                  <div className="absolute left-0 top-0 h-full w-[120px] z-20 pointer-events-none
                                  bg-gradient-to-r from-[#FDF2F6] to-transparent" />

                  <div className="absolute right-0 top-0 h-full w-[120px] z-20 pointer-events-none
                                  bg-gradient-to-l from-[#FDF2F6] to-transparent" />

                  <div className="curve-slider">
                    <div
                      ref={sliderRef}
                      className="curve-track"
                      style={{ transform: `translateX(-${sliderOffset}px)` }}
                    >
                      {[...sliderImages, ...sliderImages].map((src, index) => (
                        <div className="curve-item" key={index}>
                          <img src={src} className="curve-img" alt="" />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div>
            <hr className="bg-black-900" />
          </div>
          <div className="mx-auto w-[90%]">
            <section
                id="section-2"
                className="
                bg-[#FEFBFC]
                flex
                flex-row
                sm:flex-col
                items-center
                justify-center
                w-full
                relative
                overflow-hidden
                py-24
                max-w-[1400px] mx-auto px-4 sm:px-4
                sm:py-12"
            >
              <div
                className="
                  flex
                  flex-col
                  justify-center
                  w-1/2
                  sm:w-full
                  pl-10
                  md:px-10
                  sm:px-4
                "
              >
                <div className="max-w-[500px] w-full">
                  <Text
                    className={`
                    text-[#771237]
                    leading-[56px]
                    text-[40px]
                    sm:text-4xl
                    ${headingClass}
                    font-bold
                  `}
                  >
                    <>
                      {" "}
                      {t("showYourLoveComma")} <br />{" "}
                      {/* {t("sendThemCakeExclamationMark")}{" "} */}
                    </>
                  </Text>

                  <Text
                    className={`
                    mt-6
                    text-[#8D4660]
                    text-base
                    leading-6
                    ${interClass}
                    text-[18px] leading-[20px]
                    sm:text-[16px] sm:leading-[24px]
                    lg:text-[20px] lg:leading-[28px]
                    `}
                  >
                    {t("thereIsNoBetterGiftThanThatOfCakeDot")}
                  </Text>

                  {/* Ratings */}
                  <div className="flex items-center gap-6 mt-6">
                    <Text className="text-sm text-[#8D4660]">
                      Loved by 5k+ customers
                    </Text>
                    <Text className="text-sm text-[#8D4660]">Highly rated</Text>
                  </div>

                  <Text
                    className={`
                      mt-6
                      text-[#8D4660]
                      text-base
                      leading-6
                      font-medium
                      ${interClass}
                      text-[18px] leading-[20px]
                      sm:text-[16px] sm:leading-[24px]
                      lg:text-[20px] lg:leading-[28px]
                    `}
                  >
                    {t("socialMediaHeading")}
                  </Text>
                  <div className="flex gap-4 mt-4 sm:flex-col">
                    <Button
                      className={`
                        btn-instagram-gradient
                        h-12
                        sm:w-full
                        px-4
                        text-sm
                        w-auto
                        ${headingClass}
                      `}
                      onClick={() => {
                        window.open(
                          "https://www.instagram.com/rabbitholesa",
                          "_blank",
                        );
                      }}
                    >
                      {t("followUSOnInstagram")}
                    </Button>

                    <Button
                      className={`
                        btn-dark-gradient
                        h-12
                        sm:w-full
                        px-4
                        text-sm
                        w-auto
                        ${headingClass}
                      `}
                      onClick={() => navigate("/all-products")}
                    >
                      {t("followUSOnTikTok")}
                    </Button>
                  </div>
                </div>
              </div>
              <div
                className="
                  w-1/2
                  sm:w-full
                  flex
                  items-center
                  justify-center
                  relative
                  mt-10
                  sm:mt-12
                "
              >
                <div className="relative">
                  <ReelStorySlider />
                </div>
              </div>
            </section>
            <div>
              <hr className="bg-black-900" />
            </div>
            <section id="section-3" className="max-w-[1400px] mx-auto px-4 sm:px-4 md:px-10">
              <div
                className="flex flex-row sm:flex-col sm:gap-4 gap-2 sm:justify-center sm:items-center justify-around w-full  mx-auto my-4
                md:px-10
                sm:px-4"
              >
                <div className="flex flex-col mx-auto relative w-full p-4">
                  <Text className={`text-[#771237] ${headingClass} text-[34px] font-semibold leading-[56px]`}>
                    {t("featuredCakes")}
                  </Text>
                  <Text
                    className={`
                      text-[#8D4660]
                      text-base
                      font-light
                      ${interClass}
                      text-[20px] leading-[24px]
                      sm:text-[16px] sm:leading-[24px]
                      lg:text-[20px] lg:leading-[28px]
                      mt-2
                      whitespace-normal
                      break-words
                    `}
                  >
                    {t("eachCakeTellsAUniqueStoryOfCelebration")}
                  </Text>
                </div>
                <Button
                  className={`
                    h-12
                    sm:w-full
                    w-[15%]
                    px-2
                    mt-10
                    mx-auto
                    text-center
                    rounded-full
                    bg-[#761237]
                    text-white-A700
                    ${headingClass} font-semibold
                    text-[14px] leading-[20px]
                    shadow-[inset_0_4px_4px_rgba(255,255,255,0.25),_0_2px_24px_rgba(0,0,0,0.15)]
                    overflow-hidden
                    transition-all duration-500
                  `}
                  onClick={() => {
                        navigate("/all-products");
                  }}
                >
                  {t("shopAll")}
                </Button>
              </div>
              <div
                className="my-6 mx-auto pr-12 md:px-10 sm:px-4"
              >
                <ProductSlider homeFeaturedProducts={homeFeaturedProducts} />
              </div>
            </section>
            <div>
              <hr className="bg-black-900" />
            </div>
            <section id="section-3" className="md:overflow-hidden max-w-[1400px] mx-auto px-4 sm:px-4">
              <div
                className="flex flex-row sm:flex-col sm:gap-4 gap-2 sm:justify-center sm:items-center justify-around w-full  mx-auto my-4  px-24 md:px-10 sm:px-4"
              >
                <div className="flex flex-col  w-full relative p-4">
                  <Text className={`text-[#771237] text-3xl ${headingClass} font-semibold`}>
                    {t("discoverYourPerfectCake")}
                  </Text>
                  <Text className={`text-[#8D4660] text-left text-base ${interClass} mt-2 max-w-[720px] font-normal
                      text-[18px] leading-[24px]
                      sm:text-[16px] sm:leading-[24px]
                      lg:text-[20px] lg:leading-[28px]`}>
                    {t("exploreOurCuratedCollectionsOccasion")}
                  </Text>
                </div>
                <Button
                  className={`
                    relative
                    h-12
                    sm:w-full
                    w-[30%]
                    px-2
                    rounded-full
                    bg-[#761237]
                    text-white-A700
                    ${headingClass} font-semibold
                    text-[14px] leading-[20px]
                    shadow-[inset_0_4px_4px_rgba(255,255,255,0.25),_0_2px_24px_rgba(0,0,0,0.15)]
                    overflow-hidden
                  `}
                  onClick={() => {
                        navigate("/all-products");
                  }}
                >
                  {t("exploreAllCategories")}
                </Button>
              </div>
              <div
                className="my-6 mx-auto  px-24 md:px-10 sm:px-4"
              >
                <CategoryGrid allCategories={allCategories} />
              </div>
            </section>
            <div>
              <hr className="bg-black-900  my-4" />
            </div>
            <section id="section-3" className="md:overflow-hidden max-w-[1400px] mx-auto px-4 sm:px-4">
              <div
                className="flex flex-col sm:gap-4 gap-2 justify-center items-center w-full  mx-auto my-6  px-24 md:px-10 sm:px-4"
              >
                <div className="flex flex-col mx-auto w-full relative p-4">
                  <Text className={`text-[#771237] text-center sm:text-left text-3xl ${headingClass} font-semibold`}>
                    {t("makeItExtraSpecial")}
                  </Text>
                  <Text
                    className={`
                      mt-2
                      inline-block
                      w-full
                      max-w-full
                      ${interClass}
                      font-normal
                      text-[#771237]
                      text-center
                      self-stretch

                      text-[16px] leading-[24px]
                      sm:text-[14px] sm:leading-[20px]
                      lg:text-[20px] lg:leading-[28px]

                      whitespace-normal
                      break-words
                    `}
                  >
                    {t(
                      "addASpecialTouchToYourCakeWithOurCuratedSelectionOfGiftsAnd"
                    )}
                  </Text>
                </div>
                <Button
                  className={`
                    relative
                    h-12
                    sm:w-full
                    w-[20%]
                    px-4
                    rounded-full
                    bg-[#761237]
                    text-white-A700
                    ${headingClass} font-semibold
                    text-[14px] leading-[20px]
                    shadow-[inset_0_4px_4px_rgba(255,255,255,0.25),_0_2px_24px_rgba(0,0,0,0.15)]
                    overflow-hidden
                  `}
                >
                  {t("shopAllAddOns")}
                </Button>
              </div>
              <div
                className="my-6 mx-auto  px-24 md:px-10 sm:px-4"
              >
                <CategorySlide allCategories={addOnsSubCategories}/>
              </div>
            </section>
            <div>
              <hr className="bg-black-900  my-4" />
            </div>
            <section id="section-3" className="md:overflow-hidden max-w-[1400px] mx-auto px-4 sm:px-4">
              <div
                className="flex flex-col sm:gap-4 gap-2 justify-center items-center w-full  mx-auto my-6  px-24 md:px-10 sm:px-4"
              >
                <div className="flex flex-col mx-auto w-full relative p-4">
                  <Text className={`text-[#771237] text-center sm:text-left text-3xl ${headingClass} font-semibold`}>
                    {t("whyChooseUs")}
                  </Text>
                  <Text className={`  text-[#8D4660] text-center ${interClass} sm:text-left text-base mt-2 `}>
                    {t("discoverWhatMakesOurHandmadeCakesSpecialUs")}
                  </Text>
                </div>
              </div>
              <div
                className="my-6 mx-auto  px-24 md:px-10 sm:px-4"
              >
                <FeatureCards />
              </div>
            </section>
            <div>
              <hr className="bg-black-900" />
            </div>
            <section id="section-3" className="max-w-[1400px] mx-auto px-4 sm:px-4">
              <div
                className="flex flex-row sm:flex-col sm:gap-4 gap-2 sm:justify-center sm:items-center justify-around w-full  mx-auto my-4  px-24 md:px-10 sm:px-4"
              >
                <div className="flex flex-col mx-auto relative w-full p-4">
                  <Text className={`text-[#771237] text-3xl ${headingClass} font-semibold`}>
                    {t("cakeInspiration&Tips")}
                  </Text>
                  <Text
                    className={`
                    text-[#8D4660]
                    text-base
                    ${interClass}
                    mt-2
                    whitespace-normal
                    break-words
                  `}
                  >
                    {t("discoverRecipesDecorationIdeasAndExpertTipsToMakeEveryCelebrationSweeter")}
                  </Text>
                </div>
              </div>
              <div className="">
              <List className="w-full" orientation="horizontal">
                {blogItemCount > 4 ? (
                  <div className="">
                    <Slider
                      autoPlay
                      disableButtonsControls
                      autoPlayInterval={8000}
                      activeIndex={sliderState}
                      responsive={{
                        0: { items: 1 },
                        550: { items: 2 },
                        768: { items: 2 },
                        992: { items: 3 },
                        1050: { items: 4 },
                      }}
                      onSlideChanged={(e) => {
                        setsliderState(e?.item);
                      }}
                      ref={sliderRef}
                      className="flex gap-[30px] max-w-[1110px] mt-[50px] mx-auto  xs:mx-0 w-full"
                      items={blogList.map((items, index) => {
                        return (
                          <HomeBlog
                            keys={index}
                            data={items}
                            userimage={items?.imageLink}
                            likeBlog={likeBlog}
                            viewcount={CUSTOM.formatViewCount(items?.views)}
                            likecount={CUSTOM.formatViewCount(items?.likes)}
                            title={CUSTOM.getdataByLangKey(
                              items?.blogLocales,
                              "",
                              "title",
                            )}
                            description={CUSTOM.getdataByLangKey(
                              items?.blogLocales,
                              "",
                              "shortDescription",
                            )}
                          />
                        );
                      })}
                      renderDotsItem={({ isActive }) => {
                        if (isActive) {
                          return (
                            <div className="inline-block cursor-pointer h-2 bg-black-900 w-4 rounded" />
                          );
                        }
                        return (
                          <div
                            className="inline-block cursor-pointer rounded-[50%] h-2 bg-gray-300 w-2"
                            role="button"
                            tabIndex={0}
                          />
                        );
                      }}
                    />
                    <PagerIndicator
                      className="flex h-2 justify-center my-12 mx-auto w-20"
                      count={blogItemCount}
                      activeCss="inline-block cursor-pointer h-2 bg-[#771237] w-4 rounded"
                      activeIndex={sliderState}
                      inactiveCss="inline-block cursor-pointer rounded-[50%] h-2 bg-[#FCEDF3] w-2"
                      sliderRef={sliderRef}
                      selectedWrapperCss="inline-block md:ml-[0] mx-[4.00px] sm:ml-[0]"
                      unselectedWrapperCss="inline-block md:ml-[0] mx-[4.00px] sm:ml-[0]"
                    />
                  </div>
                ) : (
                  <>
                    {blogList.length ? (
                      <List
                        className="gap-[30px] grid xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 grid-cols-4 justify-center max-w-[1110px] mt-[31px] mx-auto md:px-5 w-full mb-8"
                        orientation="horizontal"
                      >
                        {blogList.map((items, index) => {
                          return (
                            <HomeBlog
                              keys={index}
                              data={items}
                              userimage={items?.imageLink}
                              likeBlog={likeBlog}
                              viewcount={CUSTOM.formatViewCount(items?.views)}
                              likecount={CUSTOM.formatViewCount(items?.likes)}
                              title={CUSTOM.getdataByLangKey(
                                items?.blogLocales,
                                "",
                                "title",
                              )}
                              description={CUSTOM.getdataByLangKey(
                                items?.blogLocales,
                                "",
                                "shortDescription",
                              )}
                            />
                          );
                        })}
                      </List>
                    ) : null}
                  </>
                )}
              </List>
            </div>
            </section>
          </div>
          <div className="flex font-nunitoregular items-center justify-center mt-10 md:px-5 w-[85%] sm:w-full mx-auto left-10 max-w-[1400px] mx-auto px-4 sm:px-4">
            <SubscribeCard />
          </div>
          <div className="flex font-nunitoregular items-center justify-center w-[85%] mt-[65px] sm:w-full md:px-5 mx-auto rounded-full max-w-[1400px] mx-auto px-4 sm:px-4">
            <Footer className="flex font-nunitoregular items-center justify-center  md:px-5 w-full" />
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
